module.exports = __webpack_public_path__ + "img/carousel2.77045296.svg";